export default __webpack_public_path__ + "static/media/9.Хүүхэд хамгаалалд хамтын оролцоог нэмэгдүүлэх нь.20c5a769.png";